<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs
      v-model="model"
      :background-color="$vuetify.theme.dark ? '#131c2b ' : 'white-lighten-2'"
    >
      <v-tab :href="`#tab-1`">Create New Banner</v-tab>
      <v-tab :href="`#tab-2`"> Banner History </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <div class="mt-5">
            <create-new-banner-tab></create-new-banner-tab>
          </div>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat class="mt-5">
            <banner-history-tab-data-table></banner-history-tab-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>

import BannerHistoryTabDataTable from './BannerHistoryTabDataTable.vue';
import CreateNewBannerTab from './CreateNewBannerTab.vue';

export default {
  components: { CreateNewBannerTab, BannerHistoryTabDataTable },
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
};
</script>
